import React, { useState } from 'react';
const brands = [{
  name: 'Google',
  logo: 'https://cdn.simpleicons.org/google',
  colorLogo: 'https://cdn.simpleicons.org/google/4285F4'
}, {
  name: 'Microsoft',
  logo: 'https://cdn.simpleicons.org/microsoft',
  colorLogo: 'https://cdn.simpleicons.org/microsoft/00A4EF'
}, {
  name: 'Slack',
  logo: 'https://cdn.simpleicons.org/slack',
  colorLogo: 'https://cdn.simpleicons.org/slack/4A154B'
}, {
  name: 'Stripe',
  logo: 'https://cdn.simpleicons.org/stripe',
  colorLogo: 'https://cdn.simpleicons.org/stripe/635BFF'
}, {
  name: 'Shopify',
  logo: 'https://cdn.simpleicons.org/shopify',
  colorLogo: 'https://cdn.simpleicons.org/shopify/96BF48'
}, {
  name: 'Airbnb',
  logo: 'https://cdn.simpleicons.org/airbnb',
  colorLogo: 'https://cdn.simpleicons.org/airbnb/FF5A5F'
}, {
  name: 'Spotify',
  logo: 'https://cdn.simpleicons.org/spotify',
  colorLogo: 'https://cdn.simpleicons.org/spotify/1DB954'
}, {
  name: 'Notion',
  logo: 'https://cdn.simpleicons.org/notion',
  colorLogo: 'https://cdn.simpleicons.org/notion/000000'
}];
function LogoItem({
  brand
}: {
  brand: (typeof brands)[0];
}) {
  const [hovered, setHovered] = useState(false);
  return <div className="flex items-center justify-center px-8 shrink-0 cursor-default transition-all duration-300" onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)} data-id="element-181">
      <img src={hovered ? brand.colorLogo : brand.logo} alt={brand.name} className={`h-8 w-auto object-contain transition-all duration-300 select-none ${hovered ? 'opacity-100 grayscale-0' : 'opacity-40 grayscale'}`} draggable={false} data-id="element-182" />
    </div>;
}
export function TrustStrip() {
  // Duplicate for seamless infinite loop
  const doubled = [...brands, ...brands];
  return <section className="py-12 border-y border-gray-200 bg-white overflow-hidden" data-id="element-183">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center mb-8" data-id="element-184">
        <p className="text-sm font-medium text-gray-500 uppercase tracking-wider" data-id="element-185">
          Trusted by growing brands and businesses
        </p>
      </div>

      <div className="relative overflow-hidden" data-id="element-186">
        {/* Fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" data-id="element-187" />
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" data-id="element-188" />

        <div className="flex animate-marquee" data-id="element-189">
          {doubled.map((brand, index) => <LogoItem key={`${brand.name}-${index}`} brand={brand} data-id="element-190" />)}
        </div>
      </div>
    </section>;
}